/**
 * Dispatch a custom event
 * 
 * @param {HTMLElement} obj - An html element
 * @param {String} eventName - The name of the event
 * @param {Object} options - additionnal details about the event
 */
 export const customEvent = (obj, eventName, options = {}) => {
  const event = new CustomEvent(eventName, {
    detail: options
  });
  obj.dispatchEvent(event);
}
